"use client";

import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          color: "#222222",
          fontWeight: "bold",
          fontSize: "15px",
          lineHeight: "20px",
          height: "36px",
          borderRadius: "18px",

          "&:hover": {
            backgroundColor: "#FFDF11",
          },
        },
        colorPrimary: {
          backgroundColor: "#FFDF11",
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          color: "#222222",
          fontSize: "17px",
          lineHeight: "22px",
        },
        ul: {
          gap: "8px",
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&:not(.MuiPaginationItem-ellipsis)": {
            borderRadius: "12px",
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            "&.Mui-selected": {
              backgroundColor: "#FFDF11",
              "&:hover": {
                backgroundColor: "#FFDF11",
              },
            },
          },
        },
        sizeSmall: {
          borderRadius: "8px",
        },
      },
    },
  },
});

export default theme;
